module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_m_piebald.e3e8dd38.png";